// ============================================
// App Module - State (Zustand 기반)
// ============================================

import { useAppStore } from '../../stores/appStore.js';
import { useAuthStore } from '../../stores/authStore.js';

// ============================================
// 상태 Getter 함수 (Zustand에서 읽기)
// ============================================

export function getCurrentUser() {
  return useAuthStore.getState().currentUser;
}

export function getCurrentRoomId() {
  return useAppStore.getState().currentRoomId;
}

export function getCurrentSessionId() {
  return useAppStore.getState().currentSessionId;
}

export function getCurrentChatId() {
  return useAppStore.getState().currentChatId;
}

export function getCurrentProfile() {
  return useAppStore.getState().currentProfile;
}

export function getCurrentChatData() {
  return useAppStore.getState().currentChatData;
}

export function getCurrentTurnCount() {
  return useAppStore.getState().currentTurnCount;
}

export function isProcessing() {
  return useAppStore.getState().isProcessing;
}

// ============================================
// 상태 Setter 함수 (Zustand에 쓰기)
// ============================================

export function setCurrentRoomId(roomId) {
  useAppStore.getState().setCurrentRoomId(roomId);
}

export function setCurrentSessionId(sessionId) {
  useAppStore.getState().setCurrentSessionId(sessionId);
}

export function setCurrentChatId(chatId) {
  useAppStore.getState().setCurrentChatId(chatId);
}

export function setCurrentChatData(chatData) {
  useAppStore.getState().setCurrentChatData(chatData);
}

export function setCurrentProfile(profile) {
  useAppStore.getState().setCurrentProfile(profile);
}

export function setIsProcessing(value) {
  useAppStore.getState().setIsProcessing(value);
}

export function setCurrentTurnCount(value) {
  useAppStore.getState().setCurrentTurnCount(value);
}

export function incrementTurnCount() {
  useAppStore.getState().incrementTurnCount();
  return useAppStore.getState().currentTurnCount;
}

export function decrementTurnCount() {
  useAppStore.getState().decrementTurnCount();
  return useAppStore.getState().currentTurnCount;
}

// ============================================
// UI 유틸리티 함수
// ============================================

export function refreshChatUserMarkers() {
  const container = document.getElementById('messagesContainer');
  if (!container) return;

  const profile = useAppStore.getState().currentProfile;
  const chatData = useAppStore.getState().currentChatData;
  const userName = profile?.name || chatData?.userProfile?.name || null;

  if (userName) {
    container.querySelectorAll('.user-var-placeholder').forEach(el => {
      const textNode = document.createTextNode(userName);
      el.parentNode.replaceChild(textNode, el);
    });
  }
}

export function updateFixedMetaBar() {
  // 메타바 UI 삭제됨 - 함수는 호출 호환성 유지를 위해 유지
}

export function getDb() {
  return firebase.firestore();
}
